/* Article headings only. Keep the existing body TOC, IDs, content and spoilers. */
(() => {
  'use strict';
  const initialize = (scope = document) => {
    scope.querySelectorAll('.manga-article-aside').forEach((aside) => {
      const host = aside.querySelector('[data-manga-page-index-wrapper]');
      const list = host?.querySelector('[data-manga-page-index-list]');
      const section = aside.closest('.pages-article.blogs_find-garden');
      const editor = section?.querySelector('#article_editor');
      if (!host || !list || !editor || host.dataset.ready === 'true') return;
      const headings = Array.from(editor.children).filter((node) =>
        node.matches('h2:not(.txt_catch)') && node.textContent.trim()
      );
      if (!headings.length) return;
      const entries = headings.map((heading, position) => {
        if (!heading.id) {
          const base = `hp-manga-section-${position + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const text = heading.textContent.replace(/\s+/g, ' ').trim();
        const emoji = text.match(/^(\p{Extended_Pictographic}[\uFE0F\u200D\p{Extended_Pictographic}]*)\s*/u);
        const label = emoji ? text.slice(emoji[0].length) : text;
        const item = document.createElement('li');
        const link = document.createElement('a');
        const number = document.createElement('span');
        const name = document.createElement('span');
        number.className = 'hp-ranking-index__number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = emoji ? emoji[1] : String(position + 1).padStart(2, '0');
        name.textContent = label;
        // Reuse the delegated body-TOC handler: these links are created after common.js binds anchors.
        link.className = 'noscroll article_scroll';
        link.setAttribute('href', `#${encodeURIComponent(heading.id)}`);
        link.append(number, name);
        item.append(link);
        list.append(item);
        return { heading, link };
      });
      host.hidden = false;
      host.dataset.ready = 'true';
      let frame = null;
      const update = () => {
        frame = null;
        const header = document.getElementById('l-header');
        const rect = header?.getBoundingClientRect();
        const fixed = header && ['fixed', 'sticky'].includes(getComputedStyle(header).position);
        const top = fixed && rect.top <= 1 && rect.bottom > 0
          ? Math.min(rect.bottom + 20, window.innerHeight / 2) : 24;
        section.style.setProperty('--manga-page-index-top', `${top}px`);
        let current = entries[0];
        entries.forEach((entry) => {
          if (entry.heading.getBoundingClientRect().top <= top + 32) current = entry;
        });
        entries.forEach((entry) => {
          if (entry === current) entry.link.setAttribute('aria-current', 'location');
          else entry.link.removeAttribute('aria-current');
        });
      };
      const schedule = () => {
        if (frame === null) frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
      const themeSection = section.closest('[id^="shopify-section-"]') || section;
      themeSection.addEventListener('shopify:section:unload', () => {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        if (frame !== null) cancelAnimationFrame(frame);
      }, { once: true });
    });
  };
  // The legacy body TOC assigns lnk_h2_* IDs during DOMContentLoaded.
  // Run after its listeners so both indexes keep exactly the same anchors.
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(() => initialize(), 0), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
